import * as React from 'react';
import { Stack, IStackTokens } from 'office-ui-fabric-react/lib/Stack';
import cx from 'classnames';
import styles from './index.module.scss';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { useDispatch } from 'react-redux';
import { useBoolean } from '@uifabric/react-hooks';
import { searchContent } from '../../store/Search/actions';
import { List } from 'office-ui-fabric-react/lib/List';
import { HubFile, Story } from '../../model';
import FileItem from './fileitem'
import StoryItem from './storyItem';
import { CommandButton, IContextualMenuProps } from 'office-ui-fabric-react';
import Loader from '../../components/Loader';
import { Flex, Input, SearchIcon } from '@fluentui/react-northstar';
import PopularContent from './popularcontent';

import defaultImage from '../../static/media/logo.png';

const SearchContent = ({
    onSelectionChange
}: {
    onSelectionChange: (files: {
        fileId: number;
        storyId: number;
    }[]) => void;
}) => {
    const dispatch = useDispatch();
    const {
        currentMeeting,
        theme,
    } = useTypedSelector((state: ApplicationState) => state.meeting);

    const [isFileselected, { toggle: toggleisFileselected }] = useBoolean(true);
    const {
        files: fileFromSearch,
        stories: fromSearch,
        searchProgress
    } = useTypedSelector((state: ApplicationState) => state.search);
    const [selectedStoryIds, updateSelectedStortIds] = React.useState([] as number[]);
    const [selectedFileIds, updateSelectedFileIds] = React.useState([] as {
        fileId: number;
        storyId: number
    }[]);

    const [stories, updateStories] = React.useState(fromSearch);
    const [files, updateFiles] = React.useState(fileFromSearch);
    const [selectedCacheStories, updateSelectedCacheStories] = React.useState([] as any[]);
    const [searchTem, setSearchTerm] = React.useState('');
    const [sortyType, setSortType] = React.useState('Relevance');

    React.useEffect(() => {
        const element = document.getElementById('fileSearchDialog');
        if (element != null && theme == "contrast") {
            element.style.background = "black";
            element.style.border = "1px solid #FFFFFF";
            element.style.color = "#FFFFFF";
        }
    });

    const onSearchChange = (term: string) => {
        setSearchTerm(term);
        if (term && term.length > 0) {
            dispatch(searchContent(term, isFileselected ? 'files' : 'stories', sortyType));
            updateSelectedStortIds([]);
        }
    };
    const search = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        if (searchTem && searchTem.length > 0) {
            dispatch(searchContent(searchTem, !isFileselected ? 'files' : 'stories', sortyType));
        }
        toggleisFileselected();
    }
    const stackTokens: Partial<IStackTokens> = { childrenGap: 20 };
    const onFileItemClick = (fileId: number, storyId: number) => {
        if (selectedFileIds.find(c => c.fileId === fileId)) {
            const tmpIds = selectedFileIds.filter(c => c.fileId !== fileId);
            updateSelectedFileIds(tmpIds);
            onSelectionChange && onSelectionChange(tmpIds)
        } else {
            const tmpIds = [...selectedFileIds, {
                fileId,
                storyId
            }];
            updateSelectedFileIds(tmpIds);
            onSelectionChange && onSelectionChange(tmpIds)
        }
        updateFiles([...files]);
    };
    const onFileRenderCell = (item: HubFile | undefined): JSX.Element => {
        if (!item) {
            return <></>
        }
        let isFound = false;

        if (currentMeeting.meetingContents)
            isFound = !!currentMeeting.meetingContents.find(c => c.fileId === item.id);

        return <FileItem disable={isFound} checked={!!selectedFileIds.find(c => c.fileId === item.id) || isFound} onItemClick={onFileItemClick} {...item} />
    };
    const notifyStorySelectionChange = (ids: number[]) => {
        const dataToSend: {
            fileId: number;
            storyId: number;
        }[] = [];
        ids.forEach((id) => {
            const currentStory = selectedCacheStories.find(c => c.permId === id);
            if (currentStory) {
                (currentStory.files || []).forEach((item: any) => {
                    dataToSend.push({
                        fileId: item.id,
                        storyId: currentStory.permId
                    });
                });
            }
        });
        onSelectionChange && onSelectionChange(dataToSend)
    };
    const onStoryClick = (storyId: number) => {
        if (selectedStoryIds.indexOf(storyId) >= 0) {
            const tmpIds = selectedStoryIds.filter(c => c !== storyId);
            updateSelectedStortIds(tmpIds);
            notifyStorySelectionChange(tmpIds);
        } else {
            const tmpIds = [...selectedStoryIds, storyId];
            updateSelectedStortIds(tmpIds);
            notifyStorySelectionChange(tmpIds);
        }
        updateStories([...stories]);

    }
    const onStoryRenderCell = (item: Story | undefined): JSX.Element => {
        if (!item) {
            return <></>
        }
        let isFound = false;  
        if (currentMeeting.meetingContents)
            isFound = !!currentMeeting.meetingContents.find(c => c.storyId === item.permId);

        return <StoryItem disable={isFound} checked={!!selectedStoryIds.find(c => c === item.permId) || isFound} onItemClick={onStoryClick} {...item} />
    };
    React.useEffect(() => {
        if (searchTem && searchTem.length > 0) {
            dispatch(searchContent(searchTem, isFileselected ? 'files' : 'stories', sortyType));
        }
    }, [sortyType]);

    React.useEffect(() => {
        updateStories(fromSearch);
        updateSelectedCacheStories([
            ...selectedCacheStories,
            ...fromSearch
        ]);
    }, [fromSearch])

    React.useEffect(() => {
        updateFiles(fileFromSearch.filter(c => !!c.coverArt));
    }, [fileFromSearch])
    const menuProps: IContextualMenuProps = {
        items: [
            {
                key: 'relevance',
                text: 'Relevance',
                onClick: () => {
                    setSortType('Relevance');
                }
            },
            {
                key: 'dateModified',
                text: 'Date Modified',
                onClick: () => {
                    setSortType('Date Modified');
                }
            },
            {
                key: 'title',
                text: 'Title', onClick: () => {
                    setSortType('Title');
                }
            },
        ],
    };
    const renderSearch = () => {
        return (
            <>
                <div className={styles.searchItem}>
                    <a className={cx(isFileselected && styles.selected)} onClick={search} href="#">Files</a>
                    <a className={cx(!isFileselected && styles.selected)} onClick={search} href="#">Stories</a>
                </div>
                <Stack horizontal className={styles.searchInfo}>
                    <Stack.Item grow={1}>
                        {searchTem && !searchProgress && `${isFileselected ? files.length : stories.length} ${isFileselected ? 'Files' : 'Stories'} matching "${searchTem}"`}
                    </Stack.Item>
                    <Stack.Item align='end'>
                        <CommandButton className={styles.sort} text={`Sort: ${sortyType}`} menuProps={menuProps} /></Stack.Item>
                </Stack>
                <Stack.Item grow={1} className={styles.list}>
                    {!isFileselected && <List items={stories} onRenderCell={onStoryRenderCell} />}
                    {isFileselected && <List items={files} onRenderCell={onFileRenderCell} />}
                </Stack.Item>
            </>
        )
    }
    return (
        <Stack tokens={stackTokens} className={[styles.root, styles["ms-teams-theme-" + theme]].join(' ')}>
            <Stack className={styles.header} horizontal={true}>
                <Stack><img src={defaultImage} /></Stack>
                <Stack className={styles.name} horizontalAlign="center">Bigtincan Hub</Stack>
            </Stack>
            {searchProgress && <div className={styles.loader}><Loader /></div>}
            <Input className={styles.search} fluid icon={<SearchIcon />} clearable placeholder="Search" onKeyDown={(event) => {
                event.key === "Enter" && onSearchChange((event.target as any).value)
            }
            } />
            {searchTem && searchTem.length > 0 && renderSearch()}
            {!searchTem && <PopularContent onSelectionChange={(data) => onSelectionChange && onSelectionChange(data)} />}
        </Stack>
    );

};
export default SearchContent;